export const ROUTE_PATHS = {
  HOME: '/',
  ABOUT: '/about',
  SERVICES: '/services',
  INDUSTRIES: '/industries',
  FLEET: '/fleet',
  SERVICE_AREAS: '/service-areas',
  QUOTE: '/quote',
  NEWS: '/news',
  CAREERS: '/careers',
  CONTACT: '/contact',
} as const;

export interface Service {
  id: string;
  title: string;
  description: string;
  icon: string;
  features: string[];
  benefits: string[];
  image: string;
}

export interface Industry {
  id: string;
  name: string;
  description: string;
  services: string[];
  caseStudy?: {
    title: string;
    description: string;
    results: string[];
  };
  image: string;
}

export interface FleetItem {
  id: string;
  name: string;
  category: 'trucks-trailers' | 'barges-marine' | 'heavy-equipment' | 'waste-management';
  specifications: Record<string, string>;
  availability: 'available' | 'in-use' | 'maintenance';
  image: string;
}

export interface TeamMember {
  id: string;
  name: string;
  position: string;
  bio: string;
  image: string;
}

export interface ServiceArea {
  id: string;
  name: string;
  servicesAvailable: string[];
  contactInfo: {
    phone: string;
    email: string;
  };
  keyFacilities: string[];
  image: string;
}

export interface QuoteFormData {
  service: string;
  cargoDetails: string;
  files?: File[];
  timeline: 'standard' | 'urgent' | 'emergency';
  contactName: string;
  company: string;
  email: string;
  phone: string;
  location: string;
}

export interface NewsArticle {
  id: string;
  title: string;
  date: string;
  category: 'logistics-trends' | 'supply-chain' | 'industry-insights' | 'company-news';
  excerpt: string;
  content: string;
  image: string;
  featured?: boolean;
}

export interface Career {
  id: string;
  title: string;
  location: string;
  type: 'full-time' | 'part-time' | 'contract';
  description: string;
  requirements: string[];
  responsibilities: string[];
  benefits: string[];
}